
export default function Services() {
  const services = [
    {
      icon: 'ri-car-line',
      title: 'Vehicle Acquisition',
      description: 'Strategic sourcing of quality vehicles from trusted networks and auction houses across multiple markets.'
    },
    {
      icon: 'ri-store-line',
      title: 'Inventory Management',
      description: 'Comprehensive inventory solutions with detailed vehicle histories, condition reports, and market valuations.'
    },
    {
      icon: 'ri-truck-line',
      title: 'Distribution Network',
      description: 'Efficient logistics and transportation services to deliver vehicles where and when you need them.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Market Analysis',
      description: 'Data-driven insights and market trends to help you make informed purchasing and pricing decisions.'
    },
    {
      icon: 'ri-handshake-line',
      title: 'Dealer Partnerships',
      description: 'Building long-term relationships with dealers to ensure consistent inventory flow and mutual success.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Investment Solutions',
      description: 'Structured investment opportunities for investors seeking strong returns in the automotive sector.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive wholesale automotive solutions designed to maximize efficiency and profitability for our partners
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
